export const FORM_NAME = 'Main Contact Form'

export const GENERAL_INQUIRY = 'GENERAL_INQUIRY'

export const FOUND_INQUIRY = 'FUND_INQUIRY'

export const INVESTMENT_INQUIRY = 'INVESTMENT_INQUIRY'
